export const environment = {
  production: false,
  serverurl2: 'https://www.talkmate.tw/admin',
  pic: 'https://file.talkmate.tw/',
  picfile: 'https://talkmate.tw/file/',
  socket: 'wss://webrtc-voxy.cfd888.info:8186',
  serverurl: 'http://localhost:8080/admin',
  domain: 'http://localhost:8080/',
  // serverurl: 'https://linode-voxy.cfd888.info/voxy/admin',
  // domain: 'https://linode-voxy.cfd888.info',
  // serverurl: 'https://www.talkmate.tw/voxy/admin',
  // domain: 'https://www.talkmate.tw/',
  web_net_info:'https://linode-voxy.cfd888.info/html/web/net_info.php',
  serverExcelurl: 'http://localhost:8080/admin',
  link: '/admin_rtc',
  appVersion: '1.0.0'
};
